module.exports = __webpack_public_path__ + "img/01.db542d03.png";